import React from 'react'

import { CustomTheme } from '@masfront/common-b2c'

import { makeStyles, ListItemIcon } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

import CustomListItem from './CustomListItem'
import PointerTriangle from './PointerTriangle'

const useStyles = makeStyles<CustomTheme>((theme) => ({
  root: {
    width: '100%',
    position: 'relative',

    '&.selected': {
      filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.2))',
    },
  },

  listItemIcon: {
    minWidth: theme.spacing(8),
    color: 'inherit',
  },

  dropdown: {
    transition: '.5s ease',
  },
  dropdownOpen: {
    transform: 'rotate(90deg)',
  },
  dropdownClosed: {
    transform: 'rotate(0)',
  },
}))

interface ListItemButtonProps {
  dropDown?: boolean
  open?: boolean
  onClick?: () => void
  children: React.ReactNode
  disableGutters?: boolean
  className?: string
  selected: boolean
  dataHook?: string
}

const ListItemButton: React.FC<ListItemButtonProps> = ({
  dropDown = false,
  open = false,
  children,
  disableGutters = false,
  className = '',
  selected,
  onClick = () => false,
  dataHook,
}) => {
  const classes = useStyles()

  return (
    <CustomListItem
      data-hook={dataHook}
      button
      onClick={onClick}
      className={`${className} ${classes.root} ${selected && 'selected'} list-item-button`}
      disableGutters={disableGutters}
    >
      {dropDown && (
        <ListItemIcon className={classes.listItemIcon}>
          <ArrowRightIcon
            className={`${classes.dropdown} ${
              open ? classes.dropdownOpen : classes.dropdownClosed
            }`}
            fontSize="small"
          />
        </ListItemIcon>
      )}
      {children}
      {selected && <PointerTriangle />}
    </CustomListItem>
  )
}

export default ListItemButton
